import { Breadcrumb, Typography } from "antd";
import { useEffect, useState } from "react";

const { Link } = Typography;

const getPathParts = (path: string) => {
    let paths = [];
    if (path) {
        if (path.startsWith("/")) {
            path = path.substring(1);
        }
        if (path.endsWith("/")) {
            path = path.substring(0, path.length - 1);
        }
        let pathParts = path.split("/");
        let pathBuilder = "";
        for (let part of pathParts) {
            pathBuilder = `${pathBuilder}${part}/`;
            paths.push({
                name: part,
                path: pathBuilder,
            });
        }
    }
    return paths;
};

interface IPathBreadcrumbProps {
    path: string;
    onPathClick: (path: string) => void;
    homeImageSrc?: string;
}

const PathBreadcrumb = ({ path, onPathClick, homeImageSrc }: IPathBreadcrumbProps) => {
    const [breadcrumbItems, setBreadcrumbItems] = useState(getPathParts(path));

    useEffect(() => {
        setBreadcrumbItems(getPathParts(path));
    }, [path]);

    return (
        <Breadcrumb
            items={breadcrumbItems.map((item, index) => ({
                title: (
                    <>
                        {homeImageSrc && index === 0 && <img src={homeImageSrc} alt="" className="mr-1" />}
                        <Link style={{ color: "#1890ff" }} onClick={() => onPathClick(item.path)}>
                            {item.name}
                        </Link>
                    </>
                ),
            }))}
        />
    );
};

export default PathBreadcrumb;
